import { SpinnerLoader } from 'components/molecules/Loaders';
import Separator from 'components/molecules/Separator';
import { useConfig } from 'context/app-config';
import { useBagServices } from 'hooks/useBagServices';
import { usePricing } from 'pages/queries/pricing.queries';
import React, { useMemo } from 'react';
import Container from 'react-bootstrap/Container';
import { usePricingUIStore } from 'store/pricing.ui.store';

import PricingSlider from './pricing-slider';
import PricingDetails from './pricingDetails';
import styles from './styles.module.scss';

interface Props {
  hasNoHorizontalPadding?: boolean;
}

const ServiceDetails: React.FC<Props> = ({ hasNoHorizontalPadding }) => {
  const config = useConfig();
  const { services } = useBagServices();

  const [showLoader, setShowLoader] = React.useState(true);
  const pricingType = usePricingUIStore.use.pricingType();

  const { data: pricing } = usePricing();
  const currency = pricing?.currency ?? 'AED';

  const [, serviceDetails] = useMemo(() => services?.find(([service]) => service === pricingType) ?? [undefined, undefined], [pricingType, services]);

  const PricingDetailsComponents = useMemo(
    () => (
      <>
        <PricingSlider serviceType={pricingType!!} />
        <PricingDetails serviceDetails={serviceDetails!!} currency={currency} type={pricingType!!} />
      </>
    ),
    [currency, serviceDetails, pricingType]
  );

  if (pricingType === 'SHOE_CLEANING') {
    return (
      <Container className={styles.containerIframe}>
        <Separator noMargin noMarginTop />
        {showLoader && <SpinnerLoader />}
        <iframe
          className={styles.iframe}
          title="ShoeCare"
          src={config?.shoesAndBagPricingUrl ?? 'https://www.washmen.com/app/shoes-and-bags'}
          onLoad={() => setShowLoader(false)}
        />
      </Container>
    );
  }
  if (pricingType === 'THE_FINERY') {
    return (
      <Container className={styles.containerIframe}>
        <Separator noMargin noMarginTop />
        {showLoader && <SpinnerLoader />}
        <iframe
          className={styles.iframe}
          title="The Finery"
          src="https://www.thefinery.com/in-app/finery-pricing-careem"
          onLoad={() => setShowLoader(false)}
        />
      </Container>
    );
  }

  if (!serviceDetails) {
    return null;
  }

  return hasNoHorizontalPadding ? PricingDetailsComponents : <Container className={styles.container}>{PricingDetailsComponents}</Container>;
};

ServiceDetails.displayName = 'ServiceDetails';

export default ServiceDetails;
